module.exports = __webpack_public_path__ + "static/scale-model-of-cleveland-cycle-tours-in-cleveland-ohio-2d51f73e425a5fe295250bd129797266.png";